import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.css'
})
export class PaginatorComponent {

  @Input() totalItems = 0; // Total de elementos
  @Input() initialPageSize = 5; // Tamaño de página inicial
  @Output() pageChange = new EventEmitter<{ currentPage: number; pageSize: number }>();
  currentPage = 1;
  pageSize!: number;
  totalPages = 0; // Número total de páginas

  ngOnInit(): void {
    this.pageSize = this.initialPageSize;
    this.calculateTotalPages();
    this.emitPageChange();
  }

  // Calcular el número total de páginas
  calculateTotalPages(): void {
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
  }

  // Emitir cambios de página o tamaño de página
  emitPageChange(): void {
    this.pageChange.emit({ currentPage: this.currentPage, pageSize: this.pageSize });
  }

  // Cambiar a la página anterior
  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.emitPageChange();
    }
  }

  // Cambiar a la página siguiente
  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.emitPageChange();
    }
  }

  // Manejar cambios en el tamaño de página
  onPageSizeChange(event: Event): void {
    this.pageSize = parseInt((event.target as HTMLSelectElement).value, 10);
    this.currentPage = 1; // Reiniciar a la primera página
    this.calculateTotalPages();
    this.emitPageChange();
  }
}
